export const SUPPORTED_LANGUAGES = ['en', 'es'];
